import { render, staticRenderFns } from "./transmitPage.vue?vue&type=template&id=3a57328b&scoped=true"
import script from "./transmitPage.vue?vue&type=script&lang=js"
export * from "./transmitPage.vue?vue&type=script&lang=js"
import style0 from "./transmitPage.vue?vue&type=style&index=0&id=3a57328b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57328b",
  null
  
)

export default component.exports